import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/user-topic.svg'


const _hoisted_1 = { class: "w-full custom-quill" }
const _hoisted_2 = { class: "flex mb-6" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "object-cover w-12 h-12 mr-6 rounded-full cursor-pointer",
  src: _imports_0,
  alt: "user"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "flex flex-col gap-2" }
const _hoisted_9 = { class: "text-base font-bold text-h-neutral-700" }
const _hoisted_10 = { class: "text-xs font-semibold text-h-neutral-700" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 0,
  class: "!w-full flex justify-center bg-black mt-6"
}
const _hoisted_13 = { class: "flex items-center justify-between pb-6 mt-6 text-base font-bold border-b text-h-primary-500" }
const _hoisted_14 = { class: "flex gap-3 cursor-pointer" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 0,
  class: "custom-dropdownforum md:hidden"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "custom-dropdownforum md:hidden w-12 flex justify-center" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "hidden md:flex md:gap-4 md:p-2" }
const _hoisted_22 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommentAnswer = _resolveComponent("CommentAnswer")!
  const _component_Image = _resolveComponent("Image")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      (!_ctx.comment.authorUser.photoProfile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : (_ctx.comment.authorUser.photoProfile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("img", {
                class: "object-cover w-12 h-12 mr-6 rounded-full cursor-pointer",
                src: _ctx.comment.authorUser.photoProfile.path,
                alt: "user"
              }, null, 8, _hoisted_7)
            ]))
          : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_8, [
        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.comment.authorUser.name), 1),
        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("labels.generic", {
              pt: "Publicado",
              en: "Published",
            })) + " " + _toDisplayString(_ctx.timeSinceCreation), 1)
      ])
    ]),
    _createVNode(_component_CommentAnswer, {
      "v-if": _ctx.comment.reply !== null,
      reply: _ctx.comment.reply
    }, null, 8, ["v-if", "reply"]),
    _createElementVNode("p", {
      class: "text-sm font-semibold leading-6 !p-0 !pt-1 text-h-neutral-800 ql-editor",
      innerHTML: _ctx.comment.comment
    }, null, 8, _hoisted_11),
    (_ctx.comment?.media)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(_component_Image, {
            src: _ctx.comment.media.path,
            alt: "comment image",
            preview: "",
            imageClass: "!w-full !object-cover !h-[600px] !min-h-[150px] !max-h-[450px]"
          }, null, 8, ["src"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("footer", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("span", {
          class: _normalizeClass(["flex items-center justify-center gap-2 p-2", _ctx.comment.userLiked ? 'text-h-secondary-600' : 'btn-simple']),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.likeComment && _ctx.likeComment(...args)))
        }, [
          _createVNode(_component_v_icon, {
            name: "ri-thumb-up-line",
            scale: "1"
          }),
          (_ctx.comment.likeAmount == 1)
            ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.comment.likeAmount) + " " + _toDisplayString(_ctx.$t("labels.generic", {
                pt: "curtida",
                en: "likes",
              })), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.comment.likeAmount) + " " + _toDisplayString(_ctx.$t("labels.generic", {
                pt: "curtidas",
                en: "like",
              })), 1))
        ], 2),
        _createElementVNode("a", {
          class: "flex items-center justify-center gap-2 p-2 cursor-pointer btn-simple",
          href: "#box-comment",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.replyComment && _ctx.replyComment(...args)))
        }, [
          _createVNode(_component_v_icon, {
            name: "io-arrow-undo-sharp",
            scale: "1"
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Responder",
                en: "Reply",
              })), 1)
        ])
      ]),
      _createElementVNode("span", null, [
        (_ctx.commentItems().length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createVNode(_component_Dropdown, {
                dropdownIcon: "pi pi-ellipsis-v ",
                options: _ctx.commentItems()
              }, {
                option: _withCtx((SlotProps) => [
                  _createElementVNode("button", {
                    class: "flex gap-2 items-center text-base font-bold w-[212px] btn-simple",
                    onClick: ($event: any) => (_ctx.methodHandler(SlotProps.option.method))
                  }, [
                    _createVNode(_component_v_icon, {
                      name: SlotProps.option.icon
                    }, null, 8, ["name"]),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: SlotProps.option.labelPT,
                  en: SlotProps.option.labelEN
                  })), 1)
                  ], 8, _hoisted_18)
                ]),
                _: 1
              }, 8, ["options"])
            ]))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.commentItems(), (option) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("button", {
                  class: "gap-2 btn-simple",
                  onClick: ($event: any) => (_ctx.methodHandler(option.method))
                }, [
                  _createVNode(_component_v_icon, {
                    name: option.icon,
                    scale: "0.8"
                  }, null, 8, ["name"])
                ], 8, _hoisted_20)
              ]))
            }), 256)),
        _createElementVNode("div", _hoisted_21, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commentItems(), (option) => {
            return (_openBlock(), _createElementBlock("button", {
              class: "flex items-center justify-center gap-2 cursor-pointer btn-simple",
              onClick: ($event: any) => (_ctx.methodHandler(option.method))
            }, [
              _createVNode(_component_v_icon, {
                name: option.icon
              }, null, 8, ["name"]),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: option.labelPT,
                  en: option.labelEN
                })), 1)
            ], 8, _hoisted_22))
          }), 256))
        ])
      ])
    ])
  ]))
}